import { ResponsesActivityDataItem } from '@modules/HappinessModule/interfaces/ResponsesActivityDataItem';
import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from 'shared/interfaces/asyncData';

export const getUserHappinessData = createAction<string>('userHappinessPage/getUserHappinessData');
export const setUserHappinessData = createAction<AsyncData<ResponsesActivityDataItem[]>>(
  'userHappinessPage/setUserHappinessData'
);
export const setUserHappinessDataLoading = createAction<void>('userHappinessPage/setUserHappinessDataLoading');
